import React, { useContext } from "react";
import Link from "next/link";
import QueryManagerContext from "context/QueryManager/QueryManagerContext";

type Props = {
  area: {
    seoString?: string | null;
    externalId: string;
    name: string;
  };
};

const AreaLink = ({ area }: Props) => (
  <Link href={`${area.seoString}/${area.externalId}`} passHref>
    <a data-jest="link">{area.name}</a>
  </Link>
);

type BreadCrumbProps = {
  className?: string;
};

const BreadCrumbs = ({ className = undefined }: BreadCrumbProps) => {
  const { values } = useContext(QueryManagerContext);

  if (!values.market) return null;
  if ([...values.neighborhoods, ...values.submarkets].length === 0) return null;

  if ([...values.neighborhoods, ...values.submarkets].length > 1)
    // more than one area return market crumb
    return (
      <div className={className}>
        <AreaLink area={values.market} />
      </div>
    );

  if (values.neighborhoods.length === 1) {
    // if 1 nhood then return breadcrumbs
    const submarket = values.neighborhoods[0].submarketsOfNhood?.[0];
    if (!submarket)
      return (
        <div className={className}>
          <AreaLink area={values.market} />
        </div>
      );
    return (
      <div className={className}>
        <AreaLink area={values.market} /> - <AreaLink area={submarket} />
      </div>
    );
  }

  return (
    <div className={className}>
      <AreaLink area={values.market} />
    </div>
  );
};

export default BreadCrumbs;
